import * as React from 'react';
import FlashcardsMenu from '../../../containers/Flashcards/Menu';
import FlashcardsConfig from '../../../containers/Flashcards/Config';
import MenuBurger from '../MenuBurger';
import { DexieContext, USER } from '../PageWrapper';
import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { bulkUpdate } from '../../../helpers/bulkUpdate';
import MainMenu from './MainMenu';

function Navigation() {
  const location =
    typeof window !== 'undefined' ? window.location.pathname : '';
  const [isLessonMenuOpen, setLessonMenuOpen] = useState<boolean>(false);
  const { collections } = useSelector((state: RootState) => state.hanzis);
  const db = useContext(DexieContext);

  async function handleLessonSelection(id: number) {
    setLessonMenuOpen(false);

    // Reset to new study collection
    await db.table('config').update(USER, {
      studyCollection: id,
    });

    // Reset all words from collection to study mode
    let currentLesson = collections.find((lesson) => lesson.lesson_id === id);

    const wordIds = currentLesson.hanzis;
    const updateSpecs = wordIds.map(() => ({
      isStudied: 0,
    }));

    await bulkUpdate(db.table('word'), wordIds, updateSpecs);
  }

  return (
    <>
      <MainMenu />
      {location.includes('flashcards') && (
        <>
          <FlashcardsMenu />
          <FlashcardsConfig />
        </>
      )}
      {location.includes('flashcards/study') && (
        <MenuBurger
          isOpen={isLessonMenuOpen}
          onStateChange={(state) => setLessonMenuOpen(state.isOpen)}
        >
          {collections &&
            collections.map((col) => (
              <li
                key={col.lesson_id}
                className="menu-item"
                onClick={() => handleLessonSelection(col.lesson_id)}
              >
                {col.name}
              </li>
            ))}
        </MenuBurger>
      )}
    </>
  );
}

export default Navigation;
